import { UpdatableModel } from 'projects/common/src/lib/models/updatable-model';
export class ArchitectAvailable extends UpdatableModel<ArchitectAvailable> {
  id: string;
  name: string;
  licenseNumber: string;
}
